module.exports = __webpack_public_path__ + "img/default.d143c549.jpeg";